"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6129],{

/***/ 84070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);



const NoindexRemoval = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
            children: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_ENV */ .Wi === "prod" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {}, "noindex")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoindexRemoval);


/***/ }),

/***/ 66129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ album; },
  "getServerSidePropsFunction": function() { return /* binding */ getServerSidePropsFunction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(42238);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
// EXTERNAL MODULE: ./node_modules/lodash-es/includes.js + 2 modules
var includes = __webpack_require__(19658);
// EXTERNAL MODULE: ./node_modules/lodash-es/max.js + 1 modules
var max = __webpack_require__(61303);
// EXTERNAL MODULE: ./node_modules/lodash-es/cond.js
var cond = __webpack_require__(93021);
// EXTERNAL MODULE: ./components/pages/Album/Index/index.js + 7 modules
var Index = __webpack_require__(69575);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(73221);
;// CONCATENATED MODULE: ./components/pages/Album/Index/MetaTags.js



const MetaTags = (param)=>{
    let { resolvedUrl , album , filters , searchText , tag  } = param;
    var _album_frontCover, _album_frontCover_image;
    const pathName = resolvedUrl.split("?")[0];
    const isSearchPage = /search/.test(pathName);
    const filterByTags = filters === null || filters === void 0 ? void 0 : filters.length;
    const originUrl = "".concat(constants/* LS_APP_DOMAIN */._8 + pathName);
    let path = originUrl;
    if (isSearchPage) {
        path = "".concat(originUrl, "/search?keyword=").concat(encodeURIComponent(searchText), "&page=1");
    } else if (filterByTags) {
        path = "".concat(originUrl, "?tag=").concat(filters === null || filters === void 0 ? void 0 : filters[0], "&page=1");
    } else {
        path = "".concat(originUrl, "?page=1");
    }
    let title = "室內設計裝潢風格分享，各種案例照片一籮筐－信義居家";
    let description = "彙整國內室內設計裝潢風格案例照片，無論是廚房/臥室/玄關/商業空間設計裝潢等，提供您各種風格、色系、格局裝潢參考，快來看看各種經典設計作品吧！!";
    if (isSearchPage) {
        title = "各式【".concat(searchText, "】居家設計、裝潢風格照片－信義居家");
        description = "你想找的".concat(searchText, "相關設計裝潢照片、居家風格照都在這！快來信義居家看看該如何為自己的家布置裝潢，找到自己最喜歡的居家風格，為生活增添更多色彩！");
    } else if (filterByTags) {
        if (tag === null || tag === void 0 ? void 0 : tag.name) {
            title = "各種【".concat(tag === null || tag === void 0 ? void 0 : tag.name, "】設計裝潢案例照片，找到屬於自己的居家風格－信義居家");
            description = "各種".concat(tag === null || tag === void 0 ? void 0 : tag.name, "設計裝潢案例照片都在這！快來看看如何將").concat(tag === null || tag === void 0 ? void 0 : tag.name, "靈活運用設計出自己喜歡的裝潢風格，讓整個居家空間更舒適、符合自己的居家生活習慣。");
        }
    }
    const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "首頁",
                item: "https://livinglife.com.tw"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: title,
                item: path
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: path
            }, "canonical"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }, "title"),
            !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: (album === null || album === void 0 ? void 0 : (_album_frontCover = album.frontCover) === null || _album_frontCover === void 0 ? void 0 : (_album_frontCover_image = _album_frontCover.image) === null || _album_frontCover_image === void 0 ? void 0 : _album_frontCover_image.url) || ""
            }, "og:image"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: path
            }, "og:url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumbData)
                }
            })
        ]
    });
};
/* harmony default export */ var Index_MetaTags = (MetaTags);

// EXTERNAL MODULE: ./components/common/NoindexRemoval/index.js
var NoindexRemoval = __webpack_require__(84070);
// EXTERNAL MODULE: ./utils/withLivingSinyi.js + 8 modules
var withLivingSinyi = __webpack_require__(93756);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./utils/request.js
var request = __webpack_require__(72673);
;// CONCATENATED MODULE: ./utils/api/general/getAlbums.js


const getAlbums = (props)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsGet */.UY)("/albums?".concat((0,lib.stringify)(props))));
};

;// CONCATENATED MODULE: ./utils/api/general/getAlbumCount.js


const getAlbumCount = (props)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsGet */.UY)("/albums/count?".concat((0,lib.stringify)(props))));
};

;// CONCATENATED MODULE: ./utils/api/general/getPhotoClassifications.js


const getPhotoClassifications = (props)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsGet */.UY)("/photoClassifications?".concat((0,lib.stringify)(props))));
};

;// CONCATENATED MODULE: ./utils/api/general/getPhotoTags.js


const getPhotoTags = (props)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsGet */.UY)("/photoTags?".concat((0,lib.stringify)(props))));
};

;// CONCATENATED MODULE: ./utils/api/general/getPhotoTagByUrlId.js

const getPhotoTagByUrlId = async (urlId)=>{
    const [data, error] = await (0,request/* safeAwait */.Ev)((0,request/* lsGet */.UY)("/photoTags?urlId=".concat(urlId)));
    return [
        data === null || data === void 0 ? void 0 : data[0],
        error
    ];
};

// EXTERNAL MODULE: ./utils/helpers/index.js
var helpers = __webpack_require__(30905);
;// CONCATENATED MODULE: ./pages/album/index.js









const AlbumPage = (props)=>{
    var _props_fallbackData, _props_fallbackData_albums, _props_fallbackData1, _props_fallbackData2, _props_fallbackData3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoindexRemoval/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_MetaTags, {
                resolvedUrl: props.resolvedUrl,
                album: (_props_fallbackData = props.fallbackData) === null || _props_fallbackData === void 0 ? void 0 : (_props_fallbackData_albums = _props_fallbackData.albums) === null || _props_fallbackData_albums === void 0 ? void 0 : _props_fallbackData_albums[0],
                filters: (_props_fallbackData1 = props.fallbackData) === null || _props_fallbackData1 === void 0 ? void 0 : _props_fallbackData1.filters,
                searchText: (_props_fallbackData2 = props.fallbackData) === null || _props_fallbackData2 === void 0 ? void 0 : _props_fallbackData2.searchText,
                tag: (_props_fallbackData3 = props.fallbackData) === null || _props_fallbackData3 === void 0 ? void 0 : _props_fallbackData3.photoTag
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index/* default */.ZP, {
                ...props
            })
        ]
    });
};
var __N_SSP = true;
const getServerSidePropsFunction = async (context)=>{
    var _context_query, _context_query1, _context_query2, _context_query3, _context_query4;
    const ua = ua_parser_default()(context.req.headers["user-agent"]);
    const isMobile = (0,includes/* default */.Z)([
        "mobile",
        "tablet"
    ], ua.device.type);
    const page = isMobile ? 1 : parseInt((_context_query = context.query) === null || _context_query === void 0 ? void 0 : _context_query.page) || 1;
    const filters = typeof ((_context_query1 = context.query) === null || _context_query1 === void 0 ? void 0 : _context_query1.tag) === "string" ? [
        (_context_query2 = context.query) === null || _context_query2 === void 0 ? void 0 : _context_query2.tag
    ] : ((_context_query3 = context.query) === null || _context_query3 === void 0 ? void 0 : _context_query3.tag) || [];
    const searchText = (0,helpers/* safeDecodeURIComponent */.eC)((_context_query4 = context.query) === null || _context_query4 === void 0 ? void 0 : _context_query4.keyword);
    const limit = Index/* NUMBER_PER_PAGE */.h8;
    const sorts = Index/* DEFAULT_SORT.split */.yw.split(" ");
    const skip = isMobile ? 0 : (0,max/* default */.Z)([
        page - 1,
        0
    ]) * Index/* NUMBER_PER_PAGE */.h8;
    const albumsQuery = (0,cond/* default */.Z)([
        [
            (param)=>{
                let { search  } = param;
                return !!search;
            },
            (param)=>{
                let { search  } = param;
                return {
                    search,
                    sorts,
                    limit,
                    skip
                };
            }
        ],
        [
            (param)=>{
                let { tagUrlIds  } = param;
                return tagUrlIds === null || tagUrlIds === void 0 ? void 0 : tagUrlIds.length;
            },
            (param)=>{
                let { tagUrlIds  } = param;
                return {
                    tagUrlIds,
                    sorts,
                    limit,
                    skip
                };
            }
        ],
        [
            ()=>true,
            ()=>({
                    limit,
                    sorts,
                    skip
                })
        ]
    ])({
        search: searchText,
        tagUrlIds: filters
    });
    const albumsPromise = getAlbums(albumsQuery);
    const { limit: albumLimit , sorts: albumSorts , ...albumCountQuery } = albumsQuery;
    const albumCountPromise = !isMobile && (searchText || (filters === null || filters === void 0 ? void 0 : filters.length)) ? getAlbumCount(albumCountQuery) : Promise.resolve([
        null
    ]);
    const photoClassificationsPromise = getPhotoClassifications();
    const photoTagsPromise = !isMobile && !!searchText ? getPhotoTags({
        tagName: searchText
    }) : Promise.resolve([
        []
    ]);
    const tagPromise = (filters === null || filters === void 0 ? void 0 : filters.length) ? getPhotoTagByUrlId(filters === null || filters === void 0 ? void 0 : filters[0]) : Promise.resolve([
        null
    ]);
    const [albumsResult, albumCountResult, photoClassificationsResult, photoTagsResult, tagResult] = await Promise.all([
        albumsPromise,
        albumCountPromise,
        photoClassificationsPromise,
        photoTagsPromise,
        tagPromise
    ]);
    const [albums, albumsError] = albumsResult;
    const [albumCount, albumsCountError] = albumCountResult;
    const [photoClassifications, photoClassificationsError] = photoClassificationsResult;
    const [photoTags, photoTagsError] = photoTagsResult;
    const [photoTag, photoTagError] = tagResult;
    if (albumsError) {
        // albums undefined 會造成 Next 序列化 500（意外的錯誤頁），丟給 withSafeServerSideProps 分流
        throw albumsError;
    }
    if (photoClassificationsError || albumsCountError || photoTagsError) {
        var _ref;
        const logger = __webpack_require__(41415);
        logger.warn({
            event: "gssp_fetch_error_degraded",
            page: context.resolvedUrl,
            reason: (_ref = photoClassificationsError || albumsCountError || photoTagsError) === null || _ref === void 0 ? void 0 : _ref.message
        });
    }
    return {
        props: {
            isMobile,
            fallbackData: {
                page,
                filters,
                searchText,
                // fetched data
                albums: albums !== null && albums !== void 0 ? albums : [],
                albumCount: albumCount !== null && albumCount !== void 0 ? albumCount : null,
                photoClassifications: photoClassifications !== null && photoClassifications !== void 0 ? photoClassifications : [],
                photoTags: photoTags !== null && photoTags !== void 0 ? photoTags : [],
                photoTag: photoTag !== null && photoTag !== void 0 ? photoTag : null
            },
            resolvedUrl: context.resolvedUrl
        }
    };
};
/* harmony default export */ var album = ((0,withLivingSinyi/* default */.Z)(AlbumPage));


/***/ }),

/***/ 41415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


const pino = __webpack_require__(36559);
const logger = pino({
    level:  false ? 0 : "trace",
    timestamp: pino.stdTimeFunctions.isoTime
});
const createHandler = (clientSide)=>({
        get: (target, name)=>{
            if ([
                "trace",
                "debug",
                "info",
                "warn",
                "error",
                "fatal"
            ].includes(name)) {
                return (data)=>{
                    if (typeof data === "object") {
                        target[name].call(target, {
                            ...data,
                            clientSide
                        });
                    } else {
                        target[name].call(target, data);
                    }
                };
            } else {
                return target[name];
            }
        }
    });
const clientLogger = new Proxy(logger, createHandler(true));
const serverLogger = new Proxy(logger, createHandler(false));
module.exports = {
    ...serverLogger,
    client: clientLogger
};


/***/ }),

/***/ 85346:
/***/ (function(module) {


function tryStringify (o) {
  try { return JSON.stringify(o) } catch(e) { return '"[Circular]"' }
}

module.exports = format

function format(f, args, opts) {
  var ss = (opts && opts.stringify) || tryStringify
  var offset = 1
  if (typeof f === 'object' && f !== null) {
    var len = args.length + offset
    if (len === 1) return f
    var objects = new Array(len)
    objects[0] = ss(f)
    for (var index = 1; index < len; index++) {
      objects[index] = ss(args[index])
    }
    return objects.join(' ')
  }
  if (typeof f !== 'string') {
    return f
  }
  var argLen = args.length
  if (argLen === 0) return f
  var str = ''
  var a = 1 - offset
  var lastPos = -1
  var flen = (f && f.length) || 0
  for (var i = 0; i < flen;) {
    if (f.charCodeAt(i) === 37 && i + 1 < flen) {
      lastPos = lastPos > -1 ? lastPos : 0
      switch (f.charCodeAt(i + 1)) {
        case 100: // 'd'
        case 102: // 'f'
          if (a >= argLen)
            break
          if (args[a] == null)  break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += Number(args[a])
          lastPos = i + 2
          i++
          break
        case 105: // 'i'
          if (a >= argLen)
            break
          if (args[a] == null)  break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += Math.floor(Number(args[a]))
          lastPos = i + 2
          i++
          break
        case 79: // 'O'
        case 111: // 'o'
        case 106: // 'j'
          if (a >= argLen)
            break
          if (args[a] === undefined) break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          var type = typeof args[a]
          if (type === 'string') {
            str += '\'' + args[a] + '\''
            lastPos = i + 2
            i++
            break
          }
          if (type === 'function') {
            str += args[a].name || '<anonymous>'
            lastPos = i + 2
            i++
            break
          }
          str += ss(args[a])
          lastPos = i + 2
          i++
          break
        case 115: // 's'
          if (a >= argLen)
            break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += String(args[a])
          lastPos = i + 2
          i++
          break
        case 37: // '%'
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += '%'
          lastPos = i + 2
          i++
          a--
          break
      }
      ++a
    }
    ++i
  }
  if (lastPos === -1)
    return f
  else if (lastPos < flen) {
    str += f.slice(lastPos)
  }

  return str
}


/***/ }),

/***/ 36559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



const format = __webpack_require__(85346)

module.exports = pino

const _console = pfGlobalThisOrFallback().console || {}
const stdSerializers = {
  mapHttpRequest: mock,
  mapHttpResponse: mock,
  wrapRequestSerializer: passthrough,
  wrapResponseSerializer: passthrough,
  wrapErrorSerializer: passthrough,
  req: mock,
  res: mock,
  err: asErrValue
}

function shouldSerialize (serialize, serializers) {
  if (Array.isArray(serialize)) {
    const hasToFilter = serialize.filter(function (k) {
      return k !== '!stdSerializers.err'
    })
    return hasToFilter
  } else if (serialize === true) {
    return Object.keys(serializers)
  }

  return false
}

function pino (opts) {
  opts = opts || {}
  opts.browser = opts.browser || {}

  const transmit = opts.browser.transmit
  if (transmit && typeof transmit.send !== 'function') { throw Error('pino: transmit option must have a send function') }

  const proto = opts.browser.write || _console
  if (opts.browser.write) opts.browser.asObject = true
  const serializers = opts.serializers || {}
  const serialize = shouldSerialize(opts.browser.serialize, serializers)
  let stdErrSerialize = opts.browser.serialize

  if (
    Array.isArray(opts.browser.serialize) &&
    opts.browser.serialize.indexOf('!stdSerializers.err') > -1
  ) stdErrSerialize = false

  const levels = ['error', 'fatal', 'warn', 'info', 'debug', 'trace']

  if (typeof proto === 'function') {
    proto.error = proto.fatal = proto.warn =
    proto.info = proto.debug = proto.trace = proto
  }
  if (opts.enabled === false) opts.level = 'silent'
  const level = opts.level || 'info'
  const logger = Object.create(proto)
  if (!logger.log) logger.log = noop

  Object.defineProperty(logger, 'levelVal', {
    get: getLevelVal
  })
  Object.defineProperty(logger, 'level', {
    get: getLevel,
    set: setLevel
  })

  const setOpts = {
    transmit,
    serialize,
    asObject: opts.browser.asObject,
    levels,
    timestamp: getTimeFunction(opts)
  }
  logger.levels = pino.levels
  logger.level = level

  logger.setMaxListeners = logger.getMaxListeners =
  logger.emit = logger.addListener = logger.on =
  logger.prependListener = logger.once =
  logger.prependOnceListener = logger.removeListener =
  logger.removeAllListeners = logger.listeners =
  logger.listenerCount = logger.eventNames =
  logger.write = logger.flush = noop
  logger.serializers = serializers
  logger._serialize = serialize
  logger._stdErrSerialize = stdErrSerialize
  logger.child = child

  if (transmit) logger._logEvent = createLogEventShape()

  function getLevelVal () {
    return this.level === 'silent'
      ? Infinity
      : this.levels.values[this.level]
  }

  function getLevel () {
    return this._level
  }
  function setLevel (level) {
    if (level !== 'silent' && !this.levels.values[level]) {
      throw Error('unknown level ' + level)
    }
    this._level = level

    set(setOpts, logger, 'error', 'log') // <-- must stay first
    set(setOpts, logger, 'fatal', 'error')
    set(setOpts, logger, 'warn', 'error')
    set(setOpts, logger, 'info', 'log')
    set(setOpts, logger, 'debug', 'log')
    set(setOpts, logger, 'trace', 'log')
  }

  function child (bindings, childOptions) {
    if (!bindings) {
      throw new Error('missing bindings for child Pino')
    }
    childOptions = childOptions || {}
    if (serialize && bindings.serializers) {
      childOptions.serializers = bindings.serializers
    }
    const childOptionsSerializers = childOptions.serializers
    if (serialize && childOptionsSerializers) {
      var childSerializers = Object.assign({}, serializers, childOptionsSerializers)
      var childSerialize = opts.browser.serialize === true
        ? Object.keys(childSerializers)
        : serialize
      delete bindings.serializers
      applySerializers([bindings], childSerialize, childSerializers, this._stdErrSerialize)
    }
    function Child (parent) {
      this._childLevel = (parent._childLevel | 0) + 1
      this.error = bind(parent, bindings, 'error')
      this.fatal = bind(parent, bindings, 'fatal')
      this.warn = bind(parent, bindings, 'warn')
      this.info = bind(parent, bindings, 'info')
      this.debug = bind(parent, bindings, 'debug')
      this.trace = bind(parent, bindings, 'trace')
      if (childSerializers) {
        this.serializers = childSerializers
        this._serialize = childSerialize
      }
      if (transmit) {
        this._logEvent = createLogEventShape(
          [].concat(parent._logEvent.bindings, bindings)
        )
      }
    }
    Child.prototype = this
    return new Child(this)
  }
  return logger
}

pino.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: 'trace',
    20: 'debug',
    30: 'info',
    40: 'warn',
    50: 'error',
    60: 'fatal'
  }
}

pino.stdSerializers = stdSerializers
pino.stdTimeFunctions = Object.assign({}, { nullTime, epochTime, unixTime, isoTime })

function set (opts, logger, level, fallback) {
  const proto = Object.getPrototypeOf(logger)
  logger[level] = logger.levelVal > logger.levels.values[level]
    ? noop
    : (proto[level] ? proto[level] : (_console[level] || _console[fallback] || noop))

  wrap(opts, logger, level)
}

function wrap (opts, logger, level) {
  if (!opts.transmit && logger[level] === noop) return

  logger[level] = (function (write) {
    return function LOG () {
      const ts = opts.timestamp()
      const args = new Array(arguments.length)
      const proto = (Object.getPrototypeOf && Object.getPrototypeOf(this) === _console) ? _console : this
      for (var i = 0; i < args.length; i++) args[i] = arguments[i]

      if (opts.serialize && !opts.asObject) {
        applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize)
      }
      if (opts.asObject) write.call(proto, asObject(this, level, args, ts))
      else write.apply(proto, args)

      if (opts.transmit) {
        const transmitLevel = opts.transmit.level || logger.level
        const transmitValue = pino.levels.values[transmitLevel]
        const methodValue = pino.levels.values[level]
        if (methodValue < transmitValue) return
        transmit(this, {
          ts,
          methodLevel: level,
          methodValue,
          transmitLevel,
          transmitValue: pino.levels.values[opts.transmit.level || logger.level],
          send: opts.transmit.send,
          val: logger.levelVal
        }, args)
      }
    }
  })(logger[level])
}

function asObject (logger, level, args, ts) {
  if (logger._serialize) applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize)
  const argsCloned = args.slice()
  let msg = argsCloned[0]
  const o = {}
  if (ts) {
    o.time = ts
  }
  o.level = pino.levels.values[level]
  let lvl = (logger._childLevel | 0) + 1
  if (lvl < 1) lvl = 1
  // deliberate, catching objects, arrays
  if (msg !== null && typeof msg === 'object') {
    while (lvl-- && typeof argsCloned[0] === 'object') {
      Object.assign(o, argsCloned.shift())
    }
    msg = argsCloned.length ? format(argsCloned.shift(), argsCloned) : undefined
  } else if (typeof msg === 'string') msg = format(argsCloned.shift(), argsCloned)
  if (msg !== undefined) o.msg = msg
  return o
}

function applySerializers (args, serialize, serializers, stdErrSerialize) {
  for (const i in args) {
    if (stdErrSerialize && args[i] instanceof Error) {
      args[i] = pino.stdSerializers.err(args[i])
    } else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
      for (const k in args[i]) {
        if (serialize && serialize.indexOf(k) > -1 && k in serializers) {
          args[i][k] = serializers[k](args[i][k])
        }
      }
    }
  }
}

function bind (parent, bindings, level) {
  return function () {
    const args = new Array(1 + arguments.length)
    args[0] = bindings
    for (var i = 1; i < args.length; i++) {
      args[i] = arguments[i - 1]
    }
    return parent[level].apply(this, args)
  }
}

function transmit (logger, opts, args) {
  const send = opts.send
  const ts = opts.ts
  const methodLevel = opts.methodLevel
  const methodValue = opts.methodValue
  const val = opts.val
  const bindings = logger._logEvent.bindings

  applySerializers(
    args,
    logger._serialize || Object.keys(logger.serializers),
    logger.serializers,
    logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize
  )
  logger._logEvent.ts = ts
  logger._logEvent.messages = args.filter(function (arg) {
    // bindings can only be objects, so reference equality check via indexOf is fine
    return bindings.indexOf(arg) === -1
  })

  logger._logEvent.level.label = methodLevel
  logger._logEvent.level.value = methodValue

  send(methodLevel, logger._logEvent, val)

  logger._logEvent = createLogEventShape(bindings)
}

function createLogEventShape (bindings) {
  return {
    ts: 0,
    messages: [],
    bindings: bindings || [],
    level: { label: '', value: 0 }
  }
}

function asErrValue (err) {
  const obj = {
    type: err.constructor.name,
    msg: err.message,
    stack: err.stack
  }
  for (const key in err) {
    if (obj[key] === undefined) {
      obj[key] = err[key]
    }
  }
  return obj
}

function getTimeFunction (opts) {
  if (typeof opts.timestamp === 'function') {
    return opts.timestamp
  }
  if (opts.timestamp === false) {
    return nullTime
  }
  return epochTime
}

function mock () { return {} }
function passthrough (a) { return a }
function noop () {}

function nullTime () { return false }
function epochTime () { return Date.now() }
function unixTime () { return Math.round(Date.now() / 1000.0) }
function isoTime () { return new Date(Date.now()).toISOString() } // using Date.now() for testability

/* eslint-disable */
/* istanbul ignore next */
function pfGlobalThisOrFallback () {
  function defd (o) { return typeof o !== 'undefined' && o }
  try {
    if (typeof globalThis !== 'undefined') return globalThis
    Object.defineProperty(Object.prototype, 'globalThis', {
      get: function () {
        delete Object.prototype.globalThis
        return (this.globalThis = this)
      },
      configurable: true
    })
    return globalThis
  } catch (e) {
    return defd(self) || defd(window) || defd(this) || {}
  }
}
/* eslint-enable */


/***/ })

}]);